import { Component, OnInit, OnDestroy, ViewChild, Input, AfterViewInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { SelectItem, ConfirmationService } from 'primeng/api';
import { map } from 'rxjs/operators';
import { Subscription, Subject } from 'rxjs';

import { PopupDetalheRetiradaComponent } from './popup-detalhe-retirada/popup-detalhe-retirada.component';
import { IItemInventarioDTO } from './../item-inventario/item-inventario-resumido.interface';
import { IItemProdutoRetiradaResumido } from '../item-produto-retirada/item-produto-retirada-resumido.model';
import { IItemProdutoRetirada } from '../item-produto-retirada/item-produto-retirada.model';
import { StatusRetirada } from './../../../core/enums/status-retirada.enum';
import { TipoProduto } from '../../../core/enums/produto.enum';
import { environment } from 'src/environments/environment';
import { IProdutoInput, Produto } from '../../produto/produto/produto.model';
import { FormComponent } from 'src/app/core/wireframes/app.form.component';
import { ListaComponent } from 'src/app/core/list/lista.component';
import { PopoverDropdownlistComponent } from 'src/app/core/framework/popover-dropdownlist/popover-dropdownlist.component';
import { Lote } from '../lote/lote.model';
import { Usuario } from 'src/app/seguranca/usuario/usuario/usuario.model';
import { MenuConfig } from 'src/app/core/wireframes/app.menu.config';
import { LoteFilter } from '../lote/lote.service';
import { ItemRetiradaMetadata } from './item-retirada.metadata';
import { RetiradaService } from './retirada.service';
import { MaterialService } from '../../produto/material/material.service';
import { EquipamentoService } from '../../produto/equipamento/equipamento.service';
import { MedicamentoService } from '../../produto/medicamento/medicamento.service';
import { UsuarioService } from 'src/app/seguranca/usuario/usuario/usuario.service';
import { BreadcrumbService } from 'src/app/core/framework/breadcrumb.service';
import { ListHandlerService } from 'src/app/core/list/list-handler.service';
import { ToasterService } from 'src/app/core/framework/toaster/toaster.service';
import { InventarioService } from '../inventario/inventario.service';
import { ItemInventarioService } from '../item-inventario/item-inventario.service';
import { Lista } from 'src/app/core/list/lista.model';
import { Solicitacao } from '../solicitacao/solicitacao.model';
import { ListaResultset } from 'src/app/core/list/lista-resultset.interface';
import { Medicamento } from '../../produto/medicamento/medicamento.model';
import { Material } from '../../produto/material/material.model';
import { Equipamento } from '../../produto/equipamento/equipamento.model';
import { ConfirmacaoService } from 'src/app/core/confirmacao/confirmacao.service';
import { Retirada } from './model/retirada.model';
import { RetiradaUtil } from './retirada-util';
import { PermissaoNome } from 'src/app/seguranca/perfil-de-acesso/permissao/permissao-nome.enum';
import { IItemInventarioRetirada } from './model/item-inventario-retirada.interface';
import { ProdutoFilter } from '../../produto/produto/produto.filter';
import { Unidade } from '../../unidade/unidade.model';
import { Status } from 'src/app/core/framework/default.model';
import { IItemInventarioRetiradaDTO } from './model/item-inventario-retirada-dto.interface';
import { BaixaDTO } from '../baixa-de-produto-v2/model/baixa.dto';
import { TipoDeBaixaDeProduto } from '../tipo-de-baixa-de-produto/model/tipo-de-baixa-de-produto.model';
import { TipoDeBaixaDeProdutoService } from '../tipo-de-baixa-de-produto/tipo-de-baixa-de-produto.service';
import { TipoDeBaixaDeProdutoFilter } from '../tipo-de-baixa-de-produto/model/tipo-de-baixa-de-produto.filter';
import { AutocompleteUnidadeComponent } from 'src/app/core/autocomplete-components/autocomplete-unidade/autocomplete-unidade.component';


@Component({
  selector: 'app-retirada',
  styleUrls: ['./retirada.component.css'],
  templateUrl: './retirada.component.html'
})
export class RetiradaComponent extends FormComponent implements OnInit, AfterViewInit, OnDestroy {

  static URL_LISTAGEM_DE_SOLICITACOES = 'farmacia/lote-retirada-lista';
  static URL_LISTAGEM_DE_BAIXAS = 'farmacia/baixa-de-produto-lista';

  @ViewChild('poddl') public poddl: PopoverDropdownlistComponent;
  @ViewChild('app_lista') private listaComponent: ListaComponent;
  @ViewChild('popupDetalheRetirada') private popupDetalheRetirada: PopupDetalheRetiradaComponent;

  context = this;
  queryParam: any;

  retirada = new Retirada();
  lote = new Lote();
  quantidade: number;
  usuarioSelecionado: Usuario;
  resultsetUsuarios: Usuario[];
  selectedTipoProduto: string;
  selectedTipoProdutoDescricao: string;
  tipoProduto: SelectItem[];
  resultsetProdutos: IProdutoInput[];
  formDisabled = false;
  unidadeBloqueada = false;
  resultsetMaxSize = environment.localizador_max_size;
  listFilter: LoteFilter;
  produtoSelecionado: IProdutoInput;
  subscriptionParam: Subscription;
  menuConfig: MenuConfig;
  exibirFormularioInserirProduto = true;
  itemRetiradaMetadata: ItemRetiradaMetadata;

  usuarioTemPermissaoParaAprovar = false;
  usuarioTemPermissaoParaRetirar = false;

  // ui-controler
  cssClassStatusRetirada = '';

  @ViewChild('autocompleteUnidade') private autocompleteUnidade: AutocompleteUnidadeComponent;
  private unidadeSubscription: Subscription;
  private listaSubscription: Subscription;

  public tipoDeBaixaDeProdutoSelecionado: TipoDeBaixaDeProduto;
  public tiposDeBaixaDeProduto: TipoDeBaixaDeProduto[] = [];

  @Input() public preparandoBaixa = false;

  constructor(
      private route: ActivatedRoute
      , private router: Router
      , private retiradaService: RetiradaService
      , private materialService: MaterialService
      , private equipamentoService: EquipamentoService
      , private medicamentoService: MedicamentoService
      , private usuarioService: UsuarioService
      , private breadcrumbService: BreadcrumbService
      , private listHandlerService: ListHandlerService
      , public toasterService: ToasterService
      , public confirmacaoService: ConfirmacaoService
      , private confirmationService: ConfirmationService
      , private inventarioService: InventarioService
      , private itemInventarioService: ItemInventarioService
      , private tipoDeBaixaDeProdutoService: TipoDeBaixaDeProdutoService
  ) {
      super();

      this.subscriptionParam = this.route.params.subscribe(params => {
          this.pId = +params['id'];
      });

      this.itemRetiradaMetadata = new ItemRetiradaMetadata();
  }

  setupDropDownTipoDeBaixaDeProduto(): void {
    if ( this.preparandoBaixa ) {
      const filter: TipoDeBaixaDeProdutoFilter = {
        status: Status.ATIVO
      };

      this.tipoDeBaixaDeProdutoService
          .listar(filter)
          .subscribe((resultset: ListaResultset<TipoDeBaixaDeProduto>) => {
            this.tiposDeBaixaDeProduto = resultset.content;
          });
    }
  }

  setupAutocompleteUnidade(): void {
    this.unidadeSubscription = this.autocompleteUnidade
                                    .getMyAutocomplete()
                                    .getItemSubject()
                                    .subscribe((unidade: Unidade) => {
                                      this.retirada.unidade = unidade;
                                    });
  }

  ngOnInit() {
    this.breadcrumbService.setItems([{label: 'Farmácia'}, {label: 'Saída'}]);
    this.breadcrumbService.setMenuConfig(
        this.menuConfig = this.breadcrumbService.getOrCreateMenuConfig()
            .setContext(this.context)
            .hideAll()
            .setShowVoltar(true)
            .setShowImprimir(true)
    );

    this.usuarioSelecionado = UsuarioService.getUsuarioFromLocalStorage();

    this.usuarioTemPermissaoParaAprovar = this.usuarioService.usuarioLogadoTemPermissao(PermissaoNome.ROLE_APROVAR_RETIRADA);
    this.usuarioTemPermissaoParaRetirar = this.usuarioService.usuarioLogadoTemQualquerDasPermissoes(PermissaoNome.ROLE_EFETUAR_RETIRADA,
                                                                                                    PermissaoNome.ROLE_EFETUAR_RETIRADA_PARCIAL);

    // FIXME
    this.usuarioTemPermissaoParaAprovar = true;
    this.usuarioTemPermissaoParaRetirar = true;

    this.tipoProduto = [
        { label: 'Medicamento', value: TipoProduto.MEDICAMENTO.toString() }
        , { label: 'Material', value: TipoProduto.MATERIAL.toString() }
        , { label: 'Equipamento', value: TipoProduto.EQUIPAMENTO.toString() }
    ];
    this.selectedTipoProduto = this.tipoProduto[0].value;
    this.selectedTipoProdutoDescricao = this.tipoProduto[0].label;

    setTimeout(() => {
      this.carregarRetiradaNaView();
    }, 100);
  }

  ngAfterViewInit(): void {
    this.bloquearUnidadeSeListaNaoEstiverVazia();
    this.setupDropDownTipoDeBaixaDeProduto();
    this.setupAutocompleteUnidade();
  }

  bloquearUnidadeSeListaNaoEstiverVazia(): void {
    this.listaSubscription =  this.listaComponent
                                  .getCarregarListagemSubject()
                                  .subscribe(lista => {
                                    if ( lista
                                         && lista.resultset
                                         && lista.resultset.content ) {
                                      this.unidadeBloqueada = lista.resultset.content.length > 0;
                                    }
                                    else {
                                      this.unidadeBloqueada = false;
                                    }
                                  });
  }

  onSelectUsuario(usuarioSelecionado: Usuario) {
    console.log(usuarioSelecionado);
  }

  onClearUsuario() {
    // this.lote.produto = null;
  }

  searchUsuario(event) {
    const filter = {
      size: this.resultsetMaxSize,
      status: 'A',
      nome: event.query
    };

    this.usuarioService.listar(filter)
                        .subscribe((response: ListaResultset<Usuario>) => {
                            this.resultsetUsuarios = response.content;
                        });

    switch (this.selectedTipoProduto) {
      case TipoProduto.MEDICAMENTO.toString():
          this.medicamentoService.listar(filter)
              .pipe(
                map((response: ListaResultset<Medicamento>) => this.montaStringAutocompleteProduto(response.content))
              )
              .subscribe(medicamentos => this.resultsetProdutos = medicamentos);
          break;

      case TipoProduto.MATERIAL.toString():
          this.materialService.listar(filter)
              .pipe(
                map((response: ListaResultset<Material>) => this.montaStringAutocompleteProduto(response.content))
              )
              .subscribe(materiais => this.resultsetProdutos = materiais);
          break;

      case TipoProduto.EQUIPAMENTO.toString():
          this.equipamentoService.listar(filter)
              .pipe(
                map((response: ListaResultset<Equipamento>) => this.montaStringAutocompleteProduto(response.content))
              )
              .subscribe(equipamentos => this.resultsetProdutos = equipamentos);
          break;

      default:
          break;
    }
  }

  onChangeTipoProduto(event: any) {
      switch (event.value) {
          case TipoProduto.MEDICAMENTO.toString():
              this.selectedTipoProdutoDescricao = 'Medicamento';
              break;
          case TipoProduto.MATERIAL.toString():
              this.selectedTipoProdutoDescricao = 'Material';
              break;
          case TipoProduto.EQUIPAMENTO.toString():
              this.selectedTipoProdutoDescricao = 'Equipamento';
              break;
          default:
              this.selectedTipoProdutoDescricao = 'Erro';
              break;
      }
  }

  searchProduto(event) {
    const exibirProdutosVencidos = !this.preparandoBaixa;

    const filter: ProdutoFilter = {
      size: this.resultsetMaxSize,
      status: 'A',
      descricao: event.query,
      validoEmInventario: exibirProdutosVencidos
    };

    switch (this.selectedTipoProduto) {
        case TipoProduto.MEDICAMENTO.toString():
            this.medicamentoService.listar(filter)
                .pipe(
                  map((response: ListaResultset<Medicamento>) => this.montaStringAutocompleteProduto(response.content))
                )
                .subscribe(medicamentos => this.resultsetProdutos = medicamentos);
            break;

        case TipoProduto.MATERIAL.toString():
            this.materialService.listar(filter)
                .pipe(
                  map((response: ListaResultset<Material>) => this.montaStringAutocompleteProduto(response.content))
                )
                .subscribe(materiais => this.resultsetProdutos = materiais);
            break;

        case TipoProduto.EQUIPAMENTO.toString():
            this.equipamentoService.listar(filter)
                .pipe(
                  map((response: ListaResultset<Equipamento>) => this.montaStringAutocompleteProduto(response.content))
                )
                .subscribe(equipamentos => this.resultsetProdutos = equipamentos);
            break;

        default:
            break;
      }
  }

  onSelectProduto(produtoSelecionado: IProdutoInput) {
      this.lote.produto = produtoSelecionado.produto;
  }

  onClearProduto(event: any) {
      this.lote.produto = null;
  }

  voltarParaListagemDeSolicitacoes() {
    this.router.navigate(['/' + RetiradaComponent.URL_LISTAGEM_DE_SOLICITACOES]);
  }

  voltarParaListagemDeBaixas() {
    this.router.navigate(['/' + RetiradaComponent.URL_LISTAGEM_DE_BAIXAS]);
  }

  adicionarInventarioELoteAoJsonItemRetirada(itensRetirada: IItemProdutoRetirada[]): IItemProdutoRetirada[] {
    if ( itensRetirada ) {
      itensRetirada.forEach((item) => {
          if (!item.inventario) {
              item.inventario = null;
          }
          if (!item.lote) {
              item.lote = null;
          }
      });
    }

    return itensRetirada;
  }

  carregarRetiradaNaView() {
      let exibirAprovar = false;
      let exibirReprovar = false;
      let exibirCancelar = false;
      let exibirRetirar = false;
      let exibirDevolver = false;

      if (this.pId === 0) {
        this.breadcrumbService.setItems(
          [
            {label: 'Farmácia'},
            {label: this.preparandoBaixa ? 'Baixa de produtos' : 'Solicitação'}
          ]);

        this.breadcrumbService.setMenuConfig(
          this.menuConfig.setExtraButtons(
            [
              {
                command: () => this.darBaixa()
              , visible: this.preparandoBaixa
              , title: 'Dar baixa...'
              , mat_icon: 'save'
              }
              , {
              command: () => this.solicitar()
              , visible: !this.preparandoBaixa
              , title: 'Solicitar...'
              , mat_icon: 'save'
            }
          ])
        );

        this.listHandlerService.esconderCarregando();
      }
      else {
          this.retiradaService.fetch(this.pId).subscribe(retirada => {

              this.retirada = retirada;
              this.exibirFormularioInserirProduto = this.retirada.statusRetirada === StatusRetirada.SOLICITADA;

              this.cssClassStatusRetirada = RetiradaUtil.getCssClassForStatusRetirada(this.retirada.statusRetirada);

              // carregar listagem com os produtos da retirada
              this.retiradaService
                  .listarItensRetirada(this.retirada.statusRetirada, this.pId)
                  .pipe(
                    map((response: ListaResultset<IItemProdutoRetirada>) => {
                        const itensRetirada = response.content;

                        if (this.retirada.statusRetirada === StatusRetirada.RETIRADA) {
                            return itensRetirada;
                        }
                        else {
                            return this.adicionarInventarioELoteAoJsonItemRetirada(itensRetirada);
                        }
                    })
                  )
                  .subscribe(itensProdutoRetirada => {
                      this.retirada.produtos = itensProdutoRetirada;
                      const lista: Lista = {
                          resultset: new ListaResultset<IItemProdutoRetirada>({
                            content: this.retirada.produtos
                          })
                          , cols: this.itemRetiradaMetadata.getMetadata(this.context,
                                                                   this.usuarioService,
                                                                   this.retirada.statusRetirada,
                                                                   this.inventarioService,
                                                                   this.itemInventarioService,
                                                                   this.listHandlerService,
                                                                   this.listaComponent,
                                                                   this.retirada.unidade,
                                                                   this.preparandoBaixa )
                      };
                      this.listHandlerService.refreshList({
                          filtro: null
                          , lista
                      });
                  });

                /**
                 * . se entrar em modo NOVO, exibir apenas SOLICITAR.
                 * . se entrar em alguma solicitação, exibir APROVAR, REPROVAR
                 * . se entrar em alguma solicitação APROVADA, exibir CANCELAR, RETIRAR
                 * . se entrar em alguma solicitação RETIRADA, exibir DEVOLVER
                 */
                switch ( this.retirada.statusRetirada ) {
                  case StatusRetirada.APROVADA:
                    exibirCancelar = this.usuarioTemPermissaoParaRetirar && true;
                    exibirRetirar = this.usuarioTemPermissaoParaRetirar && true;
                    break;

                  case StatusRetirada.RETIRADA:
                    // exibirDevolver = true;
                    break;

                  case StatusRetirada.REPROVADA:
                  case StatusRetirada.CANCELADA:
                  case StatusRetirada.BAIXADA:
                    break; // não exibir nenhum ActionButton para solicitações reprovadas ou canceladas

                  default:
                    exibirAprovar = this.usuarioTemPermissaoParaAprovar && true;
                    exibirReprovar = this.usuarioTemPermissaoParaAprovar && true;
                    break;
                }

                this.breadcrumbService.setMenuConfig(
                    this.menuConfig.setExtraButtons([
                        {
                            command: () => this.reprovar()
                            , visible: exibirReprovar
                            , title: 'Reprovar...'
                            , mat_icon: 'thumb_down'
                        }
                        , {
                            command: () => this.aprovar()
                            , visible: exibirAprovar
                            , title: 'Aprovar...'
                            , mat_icon: 'thumb_up'
                        }
                        , {
                            command: () => this.cancelar()
                            , visible: exibirCancelar
                            , title: 'Cancelar solicitação...'
                            , mat_icon: 'close'
                        }
                        , {
                            command: () => this.retirar()
                            , visible: exibirRetirar
                            , title: 'Efetivar retirada...'
                            , mat_icon: 'check'
                        }
                        , {
                            command: () => this.devolver()
                            , visible: exibirDevolver
                            , title: 'Devolver...'
                            , mat_icon: 'undo'
                        }
                    ])
                );
          });
      }
  }

  inserirItemRetirada(event) {
      if (this.ngForm.form.valid) {

          const _produto = this.produtoSelecionado.produto;

          // este objeto é usado para renderizar a listagem
          const itemRetirada: IItemProdutoRetirada = {
              itemProdutoRetiradaPK: {
                  produto: _produto
              }
              , inventario: null
              , lote: null
              , quantidade: this.quantidade
          };

          this.retirada.produtos.push(itemRetirada);

          const lista: Lista = {
              resultset: new ListaResultset<any>({
                content: this.retirada.produtos
              })
              , cols: this.itemRetiradaMetadata.getMetadata(this.context,
                                                            this.usuarioService,
                                                            this.retirada.statusRetirada,
                                                            this.inventarioService,
                                                            this.itemInventarioService,
                                                            this.listHandlerService,
                                                            this.listaComponent,
                                                            this.retirada.unidade,
                                                            this.preparandoBaixa )
          };
          this.listHandlerService.refreshList({
              filtro: null
              , lista
          });

          this.produtoSelecionado = null;
          this.quantidade = null;
          document.getElementById('produtoSelecionado').focus();
      }
  }

  aprovar() {
      this.confirmationService.confirm({
          header: 'Confirmação de aprovação'
          , message: 'Tem certeza que deseja aprovar esta solicitação?'
          , icon: 'fa fa-warning'
          , accept: () => {
              this.retiradaService.aprovar(this.retirada.id)
              .subscribe(retirada => {
                  this.retirada = retirada;
                  this.carregarRetiradaNaView();
              });
          }
      });
  }

  reprovar() {
      this.confirmationService.confirm({
          header: 'Confirmação de reprovação'
          , message: 'Tem certeza que deseja reprovar esta solicitação?'
          , icon: 'fa fa-warning'
          , accept: () => {
              this.retiradaService.reprovar(this.retirada.id)
              .subscribe(retirada => {
                  this.retirada = retirada;
                  this.carregarRetiradaNaView();
              });
          }
      });
  }

  cancelar() {
    this.confirmationService.confirm({
      header: 'Confirmação de cancelamento'
      , message: 'Tem certeza que deseja cancelar esta solicitação?'
      , icon: 'fa fa-warning'
      , accept: () => {
          this.retiradaService.cancelar(this.retirada.id)
          .subscribe(retirada => {
              this.retirada = retirada;
              this.carregarRetiradaNaView();
          });
      }
  });
  }

  alterarSolicitacao(idRetirada: number) {
    this.toasterService.info('Função não disponível');
    // this.retirada.idUsuarioSolicitacao = this.usuarioSelecionado.id;
    // this.retiradaService.atualizarSolicitacao(this.converterJsonRetiradaParaSolicitacao(this.retirada), idRetirada)
    //                     .subscribe(() => {
    //                         this.toasterService.success();
    //                     });
  }

  darBaixa() {
    this.confirmationService.confirm({
      header: 'Confirmação de baixa'
      , message: 'Tem certeza que deseja dar baixa nestes produtos?'
      , icon: 'fa fa-warning'
      , accept: () => {
        this.darBaixaImpl();
      }
    })
  }

  solicitar() {
    this.confirmationService.confirm({
      header: 'Confirmação de solicitação'
      , message: 'Tem certeza que deseja realizar esta solicitação?'
      , icon: 'fa fa-warning'
      , accept: () => {
        if ( !this.retirada.unidade ) {
          this.toasterService.warning('Unidade não informada');
          return;
        }

        this.retirada.idUsuarioSolicitacao = this.usuarioSelecionado.id;
        this.retiradaService.solicitar(this.converterJsonRetiradaParaSolicitacao(this.retirada))
                            .subscribe(() => {
                                this.toasterService.success();
                                this.voltarParaListagemDeSolicitacoes();
                            });
      }
    });
  }

  retirar() {
    this.confirmationService.confirm({
        header: 'Confirmação de retirada'
        , message: 'Tem certeza que deseja efetivar esta retirada?'
        , icon: 'fa fa-warning'
        , accept: () => {
          const _itensInventarioDTO: IItemInventarioDTO[] = [];
          let i: number;

          const conteudoLista = this.listaComponent.getContent();

          if ( !conteudoLista || conteudoLista.length === 0 ) {
            this.context.toasterService.info('Nenhum produto encontrado');

            return;
          }

          for (i = 0; i < conteudoLista.length; i++) {
            const jsonLinha = conteudoLista[i];

            if (jsonLinha.idItemInventario && jsonLinha.quantidade > 0) {
              _itensInventarioDTO.push({
                  idItemInventario: jsonLinha.idItemInventario
                  , quantidade: jsonLinha.quantidade
              });
            }
            else {
              this.context.toasterService.warning('Todos os produtos precisam ter setor, lote e quantidade');
              return;
            }
          }

          if (_itensInventarioDTO.length === 0) {
            this.context.toasterService.info('Nenhum produto encontrado');
          }
          else {
            this.retiradaService.retirar(this.retirada.id, _itensInventarioDTO)
                                .subscribe(retirada => {
                                  this.toasterService.success();
                                  this.voltarParaListagemDeSolicitacoes();
                                });
          }
        }
    });
  }

  devolver() {
    this.toasterService.info('Função não disponível');
  }

  validarBaixa(iirDTOs: IItemInventarioRetiradaDTO[]): boolean {
    if ( !iirDTOs ) {
      return false;
    }

    if ( this.tiposDeBaixaDeProduto.length > 0 && !this.tipoDeBaixaDeProdutoSelecionado ) {
      this.toasterService.warning('TIPO DE BAIXA é um campo obrigatório');
      return false;
    }

    for ( const item of iirDTOs ) {
      if ( !item.idItemInventario || !item.quantidade ) {
        return false;
      }
    }

    return true;
  }

  darBaixaImpl(): void {
    const iirDTOs: IItemInventarioRetiradaDTO[] = this.converterJsonRetiradaParaBaixaDTO(this.retirada);

    if ( this.validarBaixa(iirDTOs) ) {
      const baixaDTO: BaixaDTO = {
        itensInventario: iirDTOs,
        itensEstoque: [],
        observacao: this.retirada.observacao,
        tipoDeBaixaDeProduto: this.tipoDeBaixaDeProdutoSelecionado
      };

      this.retiradaService
          .baixar(baixaDTO)
          .subscribe((retirada: Retirada) => {
            if ( retirada ) {
              this.toasterService.success();
              this.voltarParaListagemDeBaixas();
            }
            else {
              this.toasterService.error();
            }
          });
    }
    else {
      this.toasterService.warning('Operação não realizada', 'Verifique se todos os itens possuem LOTE e QUANTIDADE');
    }
  }

  ngOnDestroy() {
    if ( this.subscriptionParam ) {
      this.subscriptionParam.unsubscribe();
    }

    if ( this.unidadeSubscription ) {
      this.unidadeSubscription.unsubscribe();
    }

    if ( this.listaSubscription ) {
      this.listaSubscription.unsubscribe();
    }
  }

  converterJsonRetiradaParaBaixaDTO(retirada: Retirada): IItemInventarioRetiradaDTO[] {
    const iirDTOs: IItemInventarioRetiradaDTO[] = [];
    const ipr: IItemProdutoRetirada[] = retirada.produtos;

    ipr.forEach((item: IItemProdutoRetirada) => {
      const iirDTO: IItemInventarioRetiradaDTO = {
        idItemInventario: item.idItemInventario
        , quantidade: item.quantidade
      };
      iirDTOs.push(iirDTO);
    });

    return iirDTOs;
  }

  converterJsonRetiradaParaSolicitacao(retirada: Retirada): Solicitacao {
      const solicitacao: Solicitacao = {
          idUsuarioSolicitacao: retirada.idUsuarioSolicitacao
          , idUnidade: retirada.unidade.id
          , produtos: this.converterJsonItemRetiradaParaItemRetiradaResumido(retirada.produtos)
          , observacao: this.retirada.observacao
      };

      return solicitacao;
  }

  converterJsonItemRetiradaParaItemRetiradaResumido(itensRetirada: IItemProdutoRetirada[]): IItemProdutoRetiradaResumido[] {
      const _itensRetiradaResumido: IItemProdutoRetiradaResumido[] = [];
      itensRetirada.forEach((item) => {
          _itensRetiradaResumido.push(
              {
                  idProduto: item.itemProdutoRetiradaPK.produto.id
                  , tipo: item.itemProdutoRetiradaPK.produto.tipo
                  , quantidade: item.quantidade
              }
          );
      });
      return _itensRetiradaResumido;
  }

  carregarPopoverDropdownInventario(pInventarioService: any) {
      pInventarioService.list(null)
      .subscribe(inventarios => {
          return inventarios;
      });
  }

  montaStringAutocompleteProduto(produtos: Produto[]): IProdutoInput[] {
      const stringProdutos = new Array<IProdutoInput>();
      let o: string;
      for (const produto of produtos) {
          o = '';
          if (produto.idExterno) {
              o += produto.idExterno;
          }
          if (produto.descricao) {
              if (o) {
                  o += ' - ';
              }
              o += produto.descricao;
          }
          if (produto.tuss) {
              if (o) {
                  o += ' - ';
              }
              o += produto.tuss;
          }
          stringProdutos.push({label: o, produto: produto});
      }
      return stringProdutos;
  }

  abrirPopupDetalheRetirada(event: any, dadosLinha: IItemProdutoRetirada, dadosTabela: IItemProdutoRetirada[]): Subject<IItemInventarioRetirada[]> {
    const idUnidade = ( this.retirada.unidade ? this.retirada.unidade.id : null );
    return this.popupDetalheRetirada.show(event, dadosLinha, dadosTabela, idUnidade);
  }
}

